export default {
    data() {
        return {
            isLoading: true,
            loaderOptions: {
                height: 60,
                width: 100,
                color: '#cc0000',
                backgroundColor: '#000',
                loader: 'dots',
                opacity: 0.7
            }
        }
    }
  }